import React from "react";

/**
 * Parça ünitesinin kimlik alanları (metadata) — tabloda tek hücre.
 *
 * Neden genel: donanım kimliği eskiden `hardwareId` adlı ÖZEL bir alandı,
 * 2026-08-12'de kaldırılıp metadata sistemine taşındı (parça tipinde
 * `metadataFields` ile tanımlanır). Bu yüzden burada sabit bir anahtar
 * beklenmez — üniteye yazılmış TÜM metadata anahtarları gösterilir, ileride
 * panelden yeni alan tanımlanınca kod değişikliği gerekmez.
 *
 * Sunucu tarafında `metadata` bir Mongoose Map'tir; liste uçları `.lean()`
 * kullandığı için düz obje gelir. Tekil uçlarda `toObject({ flattenMaps: true })`
 * ile düzleştirilir — aksi halde `{}` görünür.
 */
export default function MetadataCell({ metadata, compact = false }) {
  const entries = Object.entries(metadata || {}).filter(
    ([, value]) => value !== null && value !== undefined && value !== "",
  );

  if (entries.length === 0) {
    return compact ? null : <span className="text-xs text-gray-300">-</span>;
  }

  return (
    <div className={`flex flex-col ${compact ? "gap-0.5 mt-0.5" : "gap-1"}`}>
      {entries.map(([key, value]) => (
        <span
          key={key}
          className="inline-flex items-baseline gap-1 min-w-0"
          title={`${key}: ${value}`}
        >
          <span
            className={`text-gray-400 shrink-0 ${compact ? "text-[10px]" : "text-[11px]"}`}
          >
            {key}
          </span>
          <span
            className={`font-mono text-gray-700 truncate ${compact ? "text-[10px]" : "text-xs"}`}
          >
            {String(value)}
          </span>
        </span>
      ))}
    </div>
  );
}
